import { useState } from "react";
import { Modal, Form, Input, message, Upload, Button, Image, Select, Row, Col } from "antd";
import callApi from "../../constants/API/CallApi";
import "react-phone-input-2/lib/style.css";
import { ShowToast, Severty } from "../../helper/toast";
import { addBranch, getCities } from "../../constants/API/API";
import { uploadFileToS3 } from "../../helper/uploadImage";
import { UploadOutlined } from "@ant-design/icons";
import useApi from "../../hooks/useApi";

const FileType = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/avif",
  "image/webp",
  "image/gif",
];
const BranchAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [file, setFile] = useState([]);
  const [cities, setCities] = useState([]);
  const [image, setImage] = useState([]);
  const [phone, setPhone] = useState({
    mobileNumber: "",
    countryCode: "",
  });

  useApi({
    callback: getCities,
    payload: {},
    onSuccess: ({list})=>{
      setCities(list || [])
    },
    onError: (er)=>{
      console.log(er);
    }
  })

  // Update gallery state on upload
  const handleGalleryChange = ({ fileList }) => {
    // Only keep files with uploaded URLs
    if (FileType.includes(fileList?.[0]?.type)) {
      setGallery(
        fileList
          .filter(
            (f) =>
              f.status === "done" &&
              (f.url || (f.response && f.response.Location))
          )
          .map((f) => f.url || (f.response && f.response.Location))
      );
    } else {
      setGallery([]);
      form.setFieldsValue({ gallery: [] });
      return false;
    }
  };

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: addBranch,
      payload: {
        ...values,
        ...phone,
        gallery, // <-- Send the gallery array
      },
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        setGallery([]); // Reset gallery state
        refresh(new Date().getTime());
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const validateName = (rule, value) => {
    if (!value) {
      return Promise.reject("Please enter a name");
    } else if (!/^[A-Z][a-zA-Z ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters"
      );
    } else {
      return Promise.resolve();
    }
  };

  const hide = () => {
    setVisible(false);
    form.resetFields();
  };

  const handleChangeMobileNumber = (value, country) => {
    const { dialCode } = country;
    const mobileNumber = value.split(dialCode)[1];
    setPhone({
      mobileNumber: mobileNumber,
      countryCode: dialCode,
    });
  };

  const beforeUpload = (file) => {
    if (FileType.includes(file.type)) {
    } else {
      setGallery([]);
      form.setFieldsValue({ gallery: [] });
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  const handleChange = async (event) => {
    const { file } = event;

    setLoading(true); // Set uploading to true when the upload starts
    uploadFileToS3({ file, dirName: "tutorly/profile" })
      .then((data) => {
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data.Location,
          thumbUrl: data.Location,
        };
        setFile([fileData]);
        setImage(data.Location);
        form.setFieldsValue({ image: data.Location });
        setLoading(false); // Set uploading to false when the upload completes
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // Set uploading to false if the upload fails
      });
  };

  const handleRemove = async () => {
    setFile([]);
    setImage("");
  };

  return (
    <Modal
      width={800}
      open={visible}
      className="tab_modal"
      title="Add Branch"
      okText="Ok"
      centered
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={handleOk} layout="vertical">
        <Row gutter={12}>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              name="name"
              label="Branch Name"
              rules={[{ required: true, validator: validateName }]}
            >
              <Input placeholder="Enter branch name" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="city"
              label="City"
              rules={[{ required: true, message: "Please enter the city" }]}
            >
              <Select placeholder="Select City">
                {cities.map((city) => (
                  <Select.Option key={city?._id}>{city?.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              name="address"
              label="Full Address"
              rules={[
                { required: true, message: "Please enter the full address" },
              ]}
            >
              <Input placeholder="Enter full address" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              name="description"
              label="Details"
              rules={[{ required: true, message: "Please enter details" }]}
            >
              <Input placeholder="Enter additional details" />
            </Form.Item>
          </Col>
          <Col span={24}>
            {" "}
            <Form.Item
              name="gallery"
              label="Gallery (Multiple Images)"
              valuePropName="fileList"
              getValueFromEvent={(e) => e?.fileList}
            >
              <Upload
                listType="picture"
                multiple
                beforeUpload={beforeUpload}
                customRequest={async ({ file, onSuccess }) => {
                  try {
                    if (beforeUpload(file) === false) {
                      ShowToast("File formats is not correct", Severty.ERROR);
                      form.setFieldsValue({ gallery: [] });
                      return setGallery([]);
                    }
                    const result = await uploadFileToS3({
                      file,
                      dirName: "dojo/branchGallery",
                    });
                    file.url = result.Location;
                    file.thumbUrl = result.Location;
                    onSuccess(file, file);
                  } catch (err) {
                    message.error("Failed to upload image");
                  }
                }}
                onChange={handleGalleryChange} // <-- Add this
              >
                <Button icon={<UploadOutlined />}>Upload Gallery Images</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BranchAdd;
